
import chain from '@/lib/axios-chain'
import { apiRealBackDomain } from '@/lib/config'

// 精准回传创建项目设置负责人获取用户列表
// export const getRealbackAdminId = () => chain.create('/manage/wechatservices/auth/project/createprousers', 'get', apiRealBackDomain)

// 创建项目
export const createProject = () => chain.create('/manage/wechatservices/auth/project/createpro', 'post', apiRealBackDomain)

// 修改项目
export const editProject = () => chain.create('/manage/wechatservices/auth/project/modifyprojectname', 'post', apiRealBackDomain)

// 删除项目
export const delProject = () => chain.create('/manage/wechatservices/auth/project/deletepro', 'post', apiRealBackDomain)

// 关闭项目
export const closeProject = () => chain.create('/manage/wechatservices/auth/project/closepro', 'post', apiRealBackDomain)

// 打开项目
export const openProject = () => chain.create('/manage/wechatservices/auth/project/reopenpro', 'post', apiRealBackDomain)

// 精准回传选择项目
export const chooseProject = () => chain.create('/manage/wechatservices/auth/project/choose', 'post', apiRealBackDomain)
